import axios from 'axios'

export const state = {
  authorize: false,
  errorLogin: ''
}

export const getters = {
  isErrorLogin: state => state.errorLogin
}

export const actions = {
  login ({commit}, user) {
    return new Promise((resolve, reject) => {
      commit('SET_ERROR_LOGIN', '')
      axios.post('authorize/login', { 'login': user.login, 'password': user.password })
        .then(promise => {
          localStorage.setItem('auth', true)
          resolve()
        })
        .catch(error => {
          if (error.response.data.error.message) {
            commit('SET_ERROR_LOGIN', error.response.data.error.message)
          }
        })
    })
  },
  logout ({commit}, user) {
    return new Promise(resolve => {
      localStorage.setItem('auth', false)
      axios.get('authorize/logout')
        .then(promise => {
          resolve()
        })
    })
  },
  registration ({commit}, user) {
    return new Promise(resolve => {
      axios.post('registration/register', {
        'firstname': user.firstname,
        'lastname': user.lastname,
        'organization': user.organization,
        'email': user.email,
        'mobile': user.mobile,
        'type': user.personType
      }).then(promise => {
        resolve()
      })
    })
  },
  confirm ({commit}, data) {
    return new Promise(resolve => {
      axios.post('registration/confirm', {
        'code': data.code
      }).then(promise => {
        resolve()
      })
    })
  },
  isAuthorize ({commit}) {
    return new Promise(resolve => {
      axios.get('authorize/identity').then(promise => {
        localStorage.setItem('auth', true)
        resolve()
      })
    })
  }
}

export const mutations = {
  SET_ERROR_LOGIN (state, errorText) {
    state.errorLogin = errorText
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
